// DS: DEV1
import { URLS } from '@wix/da-url';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Points from '@wix/da-ds/pkg/Icons/Points';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { getPointsPriceValidationError, POINTS_MIN_VALUE } from '../utils/profits';

import s from './PointsInput.scss';

export interface Props {
  className?: string;
  inputClassName?: string;
  value: number; // int
  maxValue?: number;
  label?: string;
  errorMessage?: string | null;
  showWhatArePointsLink?: boolean;
  onChange: (value: number, errorMessage: string | undefined) => void;
  refInput?: (elem: HTMLInputElement) => void;
}

export const PointsInput: React.FC<Props> = ({
  className,
  inputClassName,
  value,
  maxValue,
  label,
  errorMessage,
  showWhatArePointsLink,
  onChange,
  refInput,
}) => {
  const { t } = useTranslation();

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const stringValue = ev.target.value;
    const limitedValue = Math.abs(+Number(stringValue.slice(0, 6)).toFixed(0));

    onChange(limitedValue, getPointsPriceValidationError(limitedValue, maxValue!, t));
  };

  return (
    <div className={classnames(s['root'], className)}>
      <div className={s['points-input-line']}>
        <TextInput
          id="points-input"
          className={classnames(s['points-cost-input'], inputClassName)}
          value={value ? value.toString() : ''}
          validationResult={errorMessage ? 'error' : undefined}
          details={errorMessage}
          onChange={handleChange}
          name="pointsInput"
          type="number"
          label={label || t('common.pointsInput.choosePrice')}
          min={POINTS_MIN_VALUE}
          max={maxValue}
          autoComplete="off"
          ref={refInput}
        />
        <div className={s['input-label']}>
          <Points className={s['coins-icon']} />
        </div>
      </div>
      {showWhatArePointsLink && (
        <div className={s['what-are-points-line']}>
          {!!value && (
            <a
              target="_blank"
              rel="noreferrer"
              href={URLS.ABOUT_POINTS}
              className={s['what-are-points']}
            >
              {t('common.faq.whatArePoints')}
            </a>
          )}
        </div>
      )}
    </div>
  );
};
PointsInput.displayName = 'PointsInput';

export default PointsInput;
